let inputToggles = document.querySelectorAll('[data-input-toggle]');

inputToggles.forEach(toggle => {
    toggle.addEventListener('change',
        event => {
            const toggleSelector = event.target.dataset['inputToggle'];
            if (toggleSelector) {
                const inputs = document.querySelectorAll(toggleSelector);
                inputs.forEach(input => {
                    if (toggle.checked) {
                        input.dataset['savedValue'] = input.checked;
                        input.checked = !toggle.checked;
                    } else {
                        input.checked = input.dataset['savedValue'] === 'true';
                    }
                    input.disabled = toggle.checked === true;
                });
            }
        });
});